import { render, staticRenderFns } from "./LocaleDropDown.vue?vue&type=template&id=19e62dfa"
import script from "./LocaleDropDown.vue?vue&type=script&lang=js"
export * from "./LocaleDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports